import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import '../../common/page-frames/single-form.css';
import './user-info.css';
import EducationEditor from '../../common/widgets/EducationEditor';
import JobHistoryEditor from '../../common/widgets/JobHistoryEditor';
import MenteeProgramEditor from '../../common/widgets/MenteeSelfEvaluationEditor';
import MentorProgramEditor from '../../common/widgets/MentorSelfEvaluationEditor';
import PageFrameGeneric from '../../common/page-frames/generic';
import StepBasicInfo from './StepBasicInfo';
import StepFinish from './StepFinish';
import UserInfoSteps from './UserInfoSteps';

import { UserInfoProps, UserType } from '../../types';

@inject('userInfoStore', 'userStore')
@observer
class UserInfo extends React.Component<UserInfoProps> {
  constructor(props: UserInfoProps) {
    super(props);
  }

  @action
  public componentWillMount() {
    const { history, match, userStore, userInfoStore } = this.props;

    // Redirect user to sign-in page if not logged in
    if (!userStore!.isSignedIn) {
      history.push('/sign-in');
    }

    if (!userStore!.canUpdate) {
      history.push('/dashboard');
    }

    // Determine user type; default to 'mentee' if not specified
    const paramUserType = match.params.userType;
    const isMentor: boolean = !!paramUserType && paramUserType.toLowerCase() === UserType.MENTOR;
    if (isMentor) {
      userInfoStore!.userType = UserType.MENTOR
    };
  }

  public render() {
    const { currentRenderId, userType } = this.props.userInfoStore!;

    // Determine which step to use based on user type
    const stepPrograms = userType === UserType.MENTEE
        ? <MenteeProgramEditor key={3} />
        : <MentorProgramEditor key={3} />;

    const renderSequence = [
      <StepBasicInfo key={0} />,
      <EducationEditor key={1} />,
      <JobHistoryEditor key={2} />,
      stepPrograms,
      <StepFinish key={4} />
    ];

    return (
      /**
       * This is basically an override of PageFrameSingleForm; however, this frame is single-use
       * so no need to create a new class (may need to if this frame is useful in other places).
       *
       * Reusing the 'page-frame-single-frame' class to get the same styling.
       */
      <PageFrameGeneric 
          className="user-info page-frame-single-form"
          title="Tell us about yourself"
          path="/user-info"
      >
        <section className="section">
          <div className="container">
            <div id="form-title" className="title">Tell us about yourself</div>

            {/* render the steps component on top of the page */}
            <UserInfoSteps activeId={currentRenderId}/>
            <div className="columns is-centered">
              <div id="form-content" className="columns is-multiline is-centered">

                {/* render the sub-page (Step*) according the current state*/}
                {renderSequence[currentRenderId]}

                {this.renderNavButtons()}
              </div>
            </div>
          </div>
        </section>
      </PageFrameGeneric>
    );
  }

  private renderNavButtons = () => {
    const { currentRenderId } = this.props.userInfoStore!;
    const nextButton = <a className="button is-primary" onClick={this.nextStage}>Next</a>;
    const prevButton = <a className="button is-outlined" onClick={this.previousStage}>Previous</a>;

    let navButtons;
    let wrapperSize = 'is-10';

    switch (currentRenderId) {
      case 0:
        wrapperSize = 'is-6';
        navButtons = <div className="field column is-12">{nextButton}</div>;
        break;
      case 4:
        if (!this.props.userInfoStore!.awaitServer) {
          wrapperSize = 'is-6';
          navButtons =
              <div className="field column is-12">
                <a className="button is-primary" href="/dashboard">Go to Dashboard</a>
              </div>;
        }

        break;
      default:
        navButtons = [ prevButton, nextButton ].map(
            (btn, index) => <div key={index} className="field column is-6">{btn}</div>
        );
    }

    return (
        navButtons && 
            <div className={`columns column user-info-nav-buttons ${wrapperSize}`}>
              { navButtons }
            </div>
    );
  }

  @action
  private nextStage = () => {
    this.props.userInfoStore!.currentRenderId += 1;
  }

  @action
  private previousStage = () => {
    this.props.userInfoStore!.currentRenderId -= 1;
  }
}

export default UserInfo;



// WEBPACK FOOTER //
// ./src/pages/user-info/UserInfo.tsx